import type { ReactNode } from 'react';

export type ModalFullWidthProperties = { children: ReactNode; className?: string };

const FullWidth = ({ children, className }: ModalFullWidthProperties) => <div className={className}> {children} </div>;

export default FullWidth;
